import { watch, computed, Ref } from 'vue';

import { useCurrentView } from '../composables/useCurrentView';
import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useHandleNextView } from '../composables/useHandleNextView';

import type { CalculationSegmentProductItem } from '../utils/types';

export function useSelectViewItems(selectedItems: Ref<{ [key: string]: number | null }>) {
  const { currentView } = useCurrentView();
  const { getItemValue } = useCurrentCalculation();

  const { isValid, isLoading, handleNextView, handleNextGroup } = useHandleNextView(selectedItems);

  const items = computed(() => {
    return currentView.value?.items;
  });

  const viewLinks = computed(() => {
    return currentView.value?.links || [];
  });

  watch(
    currentView,
    () => {
      if (!items.value) {
        return;
      }

      const nonRuleItems = items.value.filter((item) => item.type !== 'rule');

      selectedItems.value = nonRuleItems.reduce((accumulator, currentValue) => {
        return {
          ...accumulator,
          [currentValue.id]: getItemValue(currentValue.id),
        };
      }, {});
    },
    { immediate: true }
  );

  function getItemProductMaterials(item: CalculationSegmentProductItem) {
    const currentProduct = item.products.find(
      (product) => product.id === selectedItems.value[item.id]
    );

    return currentProduct?.educational_materials || null;
  }

  function getItemProduct(item: CalculationSegmentProductItem) {
    const currentProduct = item.products.find(
      (product) => product.id === selectedItems.value[item.id]
    );

    return currentProduct || null;
  }

  return {
    selectedItems,
    isValid,
    isLoading,
    items,
    handleNextView,
    getItemProductMaterials,
    getItemProduct,
    viewLinks,
    handleNextGroup,
  };
}
